module.exports = __webpack_public_path__ + "img/img17.d9c391d6.png";